import React, { Component } from 'react';

class ContainerLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    subtitle: 'Chapter 1',
                    title: 'Linear Algebra Tools',
                    text: 'This chapter presents the mathematical foundations needed to understand adaptive control and recurrent neural networks: dot product, norms, convolution, eigenvalues, eigenvectors, SVD, and Fourier transforms, among other essential concepts.'
                },
                {
                    id: 2,
                    subtitle: 'Chapter 2',
                    title: 'Representation of Dynamic Systems',
                    text: 'You will learn to model dynamic systems in both continuous and discrete domains, using state-space representations, transfer functions, and difference equations, as well as introducing FIR and IIR architectures and recurrent neural networks.'
                }
            ]            
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collLeft.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerLeft;
